module.exports = __webpack_public_path__ + "img/SameDayService.3e4769ed.svg";